import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { datasetSettingsFields } from '@/datasets/settings/state/state';
import { entityVisibility } from '@/constants/states';
import VisibilityDropdown from '@/components/VisibilityDropdown';
import { updateCohortProperties, updateCohort } from '../actions';
import CohortVisibilityLabel from '../components/CohortVisibilityLabel';
import { cohortPerms } from '../sharing/state/state';
import { supportedCohortVisibilities } from '../state/state';
import { cohortPermissions } from '../constants';

const CohortVisibilityChanger = ({
  code,
  category,
  datasetCohortVisibilities,
  visibility,
  updateProperties,
  update,
  disabled,
}) => {
  const submitChange = (properties) => {
    updateProperties(category, code, { saveStatus: states.PENDING });
    update(category, code, properties);
  };

  if (datasetCohortVisibilities.length <= 1) {
    return (
      <div className="float-r">
        <CohortVisibilityLabel visibility={visibility} />
      </div>
    );
  }

  return (
    <div className="float-r">
      <VisibilityDropdown
        id="cohort_visibility"
        disabled={disabled}
        onChange={submitChange}
        trigger={<CohortVisibilityLabel visibility={visibility} />}
        visibility={visibility}
        visibilityOptions={datasetCohortVisibilities}
      />
    </div>
  );
};

const mapStateToProps = ({
  auth: { role },
  cohorts: { cohorts },
}, { category, code }) => {
  const item = findResult(cohorts, category, code)
      || { visibility: entityVisibility.PRIVATE, permissions: cohortPerms(), settings: datasetSettingsFields() };
  const datasetCohortVisibilities = role.permissions.cohorts.update && item.permissions[cohortPermissions.VISIBILITY]
    ? supportedCohortVisibilities(item) : [];

  return ({
    visibility: item.visibility,
    datasetCohortVisibilities,
  });
};

const mapDispatchToProps = {
  updateProperties: updateCohortProperties,
  update: updateCohort,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortVisibilityChanger);
